import React from 'react';
import { ImageHandler } from '../../../../components';
import { Container } from './styles';

type Props = {
    logo: string;
    name: string;
}

const ExhibitorLogo: React.FC<Props> = ({ logo, name }) => {
    return (
        <Container>
            <ImageHandler
                url={logo}
                alt={name}
            />
            <span>{name}</span>
        </Container>
    );
};

export { ExhibitorLogo };
